import { render, staticRenderFns } from "./AsideView.vue?vue&type=template&id=6f7c6af2"
import script from "./AsideView.vue?vue&type=script&lang=js"
export * from "./AsideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports